( function($) {
    "use strict";

    var progessBar = function(bar) {
        var percent = parseInt(bar.getAttribute('data-percent')) + '%',
            slide = bar.querySelector('[progress-bar-slide]'),
            label = bar.querySelector('[progress-bar-percent]');

        slide.style.width = percent;
        label.innerHTML = percent;
    };

    // app instantiation
    $('body').on('app.init', function(ev) {
        var $container = $(ev.container);

        $container.find('[progress-bar]')
            .on('progress.bar', function() {
                var bars = $container.find('[progress-bar]');
                for (var i = 0; i < bars.length; i++) {
                    progessBar(bars[i]);
                }
            })
            .trigger('progress.bar');
    });

}(jQuery));
